<template>
    <transition name='fade'>
        <!-- 蒙版 -->
        <div class="msgbox-wrapper" v-if="show" @touchmove.prevent>
            <template v-if="type == 'prompt'">
                <div class="promptbox">
                    <div class="promptbox-title" v-if="title">
                        {{title}}
                    </div>         
                   <div class="promptbox-subTitle" v-if="subTitle">
                        {{subTitle}}
                    </div>                              
                    <div class="promptbox-content">
                        {{content}}
                    </div>
                    <div class="promptbox-button">
                        <span class="confirm" :style="{'backgroundColor': themeColor}" @click="confirmClick">{{confirmText}}</span>
                    </div>                
                </div>
            </template>
            <template v-else>
                <div class="msgbox">            
                    <div class="msgbox-content">
                        <span>{{content}}</span>
                    </div>
                    <div class="msgbox-button">
                        <span class="cancel" @click="cancelClick">{{cancelText}}</span>
                        <span class="confirm" :style="{'color': themeColor}" @click="confirmClick">{{confirmText}}</span>
                    </div>                
                </div>
            </template>

        </div>
    </transition>    
</template>
<script>
export default {
    name: 'app',
    data () {
        return {
            show: false,
            type: 'prompt',
            title: '',
            subTitle: '',
            content: '',
            cancelText: '',
            confirmText: '',
            cancel:'',
            confirm:'',
            themeColor: '#007AFF'
        }
    },
    created () {
    },
    methods: {
        cancelClick () {
            this.cancel();
            this.show = false;
        },
        confirmClick () {
            this.confirm();
            this.show = false;
        },        
    }
}
</script>
<style scoped lang='scss'>
@import "@/assets/css/healthCommon.scss";
    // 渐变过渡
    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .35s;
    }
    .msgbox-wrapper {
        // opacity: 0.8;
        background: rgba(0,0,0,0.8);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;        
        z-index: 999;
        .promptbox {
            width: 520rem/$base-font;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);

            background-color: #fff;
            border-radius: 8rem/$base-font;            
            .promptbox-title {
                width: 100%;
                padding-top: 36rem/$base-font;
                font-size: 36rem/$base-font;
                color: #333333;   
                text-align: center;
                font-family: PingFangSC-Semibold;                             
            }
            .promptbox-subTitle {
                width: 100%;
                padding-top: 36rem/$base-font;                
                font-size: 28rem/$base-font;
                text-align: center;
                color: #666666;                  
            }           
            .promptbox-content {
                margin: 32rem/$base-font 48rem/$base-font 0;
                font-size: 28rem/$base-font;
                color: #666666;  
                text-align: justify;                              
                // border-bottom: rgba(0,0,0,0.05) solid 1rem/$base-font;
                // position: relative;
                // span {
                //     position: absolute;
                //     top: 50%;
                //     left: 50%;
                //     transform: translate(-50%,-50%);
                //     width: 80%;
                //     display: inline-block;
                //     font-size: 28rem/$base-font;
                //     color: #333333;      
                //     text-align: center;  
                // }                
            }
            .promptbox-button {
                margin: 32rem/$base-font 0 24rem/$base-font;
                height: 68rem/$base-font;
                position: relative;
                .confirm {
                    display: inline-block;
                    width: 272rem/$base-font;
                    height: 68rem/$base-font;
                    line-height: 68rem/$base-font;
                    text-align: center;
                    font-size: 28rem/$base-font;
                    background-color: #0077F9;
                    color: #fff;   
                    border-radius: 34rem/$base-font;       
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }            
        }
        .msgbox {
            width: 520rem/$base-font;
            height: 258rem/$base-font;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);

            background-color: #fff;
            border-radius: 8rem/$base-font;

            .msgbox-content {
                height: 171rem/$base-font;
                border-bottom: rgba(0,0,0,0.05) solid 1rem/$base-font;
                position: relative;
                span {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    width: 80%;
                    display: inline-block;
                    font-size: 28rem/$base-font;
                    color: #333333;      
                    text-align: center;  
                }
            }
            .msgbox-button {
                height: 88rem/$base-font;
                display: flex;
                .cancel {
                    display: inline-block;
                    width: 50%;
                    height: 88rem/$base-font;
                    line-height: 88rem/$base-font;
                    text-align: center;
                    border-right: rgba(0,0,0,0.05) solid 1rem/$base-font;
                    font-size: 28rem/$base-font;
                    color: #666666;          
                }
                .confirm {
                    display: inline-block;
                    width: 50%;
                    height: 88rem/$base-font;
                    line-height: 88rem/$base-font;
                    text-align: center;
                    font-size: 28rem/$base-font;
                    color: #0077F9;          
                }
            }
        }       
    }
</style>
